export async function updateLegalEntity(legalEntityRepository, legalEntity) {
  return legalEntityRepository.update(legalEntity);
};
